module.exports = __webpack_public_path__ + "3c6dfcb9735cfb10897106a7e7908e7c.svg";